import Link from 'next/link';
import { useTranslate } from '@tolgee/react';
import { SearchScope } from '@amf/shared/components/search/hooks/useAdvancedSearch';
import { SearchResultWithNewsFragment } from '@amf/shared/types/graphql';

type Props = {
  item: SearchResultWithNewsFragment;
  prefixes: { news: string };
};

function NewsResult({ item, prefixes }: Props) {
  const { t } = useTranslate();
  return (
    <Link href={`${prefixes.news}/${item.path}`} passHref>
      <a className='AdvancedSearch__resultItem'>
        {item.photoUrl ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img src={item.photoUrl} alt={item.name} className='AdvancedSearch__resultItemImage' />
        ) : (
          <div className='AdvancedSearch__resultItemImage' />
        )}
        <div className='AdvancedSearch__resultItemContent'>
          <div className='AdvancedSearch__resultItemType'>
            {t(`search.scope.${SearchScope.NEWS}.one`)}
          </div>
          <h3 className='AdvancedSearch__resultItemTitle'>{item.name}</h3>
          <p className='AdvancedSearch__resultItemDescription'>{item.description}</p>
        </div>
      </a>
    </Link>
  );
}

export default NewsResult;
